import errorTypeConst from "@common_lib/base/constants/errorTypeConst"
import { fetchAPI } from "@/api/api"
import ApiStatusError from "@/api/errors/ApiStatusError"
import SystemMaintenanceError from "@/api/errors/SystemMaintenanceError"
import { queryInItInfoResponseSchema } from "@/schemas/websiteInfo"
import { z } from "zod/v4"
import { stringParam } from "@/schemas/requestParams"
import fillable from "@/config/openMobileReportSiteFillable"

const QUERY_INIT_INFO = "/exchange/member/playerService/queryInitInfo"

// queryInitInfo (PlayerController.java:3683-3795); lang / theme fall back to the session
const queryInitInfoRequestSchema = z.strictObject({
  lang: stringParam(2).optional(),
  theme: stringParam(10).optional()
})

const fetch = {
  url: QUERY_INIT_INFO,
  handler: async () => {
    try {
      const res = await fetchAPI({
        url: QUERY_INIT_INFO,
        method: "post",
        withCredentials: true,
        pageName: "",
        requestSchema: queryInitInfoRequestSchema,
        schema: queryInItInfoResponseSchema
      })

      return Promise.resolve({
        ...res,
        isEnableMobileReportPage:
          (res.isEnableMobileReportPage ?? false) &&
          (fillable.includes(res.webSiteDisplayName) || import.meta.env.MODE === "dev")
      })
    } catch (error) {
      if (
        error instanceof ApiStatusError &&
        error.status === errorTypeConst.SYSTEM_MAINTENANCE.status
      ) {
        return Promise.reject(new SystemMaintenanceError(error))
      }

      return Promise.reject(error)
    }
  }
}

export default fetch
